<template>
    <v-data-table
        class="elevation-2 mt-5"
        :headers="headers"
        :items="contracts"
        :items-per-page="10"
        :footer-props="{
            itemsPerPageOptions: [10, 25, 50]
        }"
        :search="search"
        :custom-filter="filterNameOrDate"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
    >
        <template v-slot:top>
            <v-row>
                <v-col cols="12" md="7">
                    <v-btn
                        v-if="visibilityConfig.refresh"
                        class="ma-2"
                        icon
                        medium
                        @click="$emit('refresh')"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </v-col>
                <v-col v-if="visibilityConfig.search" cols="12" md="5">
                    <v-text-field
                        v-model="search"
                        class="mx-5 pt-1 data-table-search"
                        :label="$t('formCommon.searchNameOrEndDate')"
                        clearable
                    />
                </v-col>
            </v-row>
        </template>
        <template v-slot:item.startDate="{ item }">
            {{ item.startDate | dateFormatFromSettings }}
        </template>
        <template v-slot:item.endDate="{ item }">
            {{ item.endDate | dateFormatFromSettings }}
        </template>
        <template v-slot:item.createdAt="{ item }">
            {{ item.createdAt | dateTimeFormatFromSettings }}
        </template>
        <template v-slot:item.status="{ item }">
            <contract-edit-status :contract="item" />
        </template>
        <template v-slot:item.action="{ item }">
            <div class="d-flex">
                <v-icon
                    v-if="visibilityConfig.actions.edit"
                    size="20"
                    class="mr-3"
                    @click="$emit('edit', item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                    v-if="visibilityConfig.actions.delete"
                    size="20"
                    class="mr-3"
                    @click="$emit('delete', item)"
                >
                    mdi-delete
                </v-icon>
                <v-icon
                    v-if="visibilityConfig.actions.showHistory"
                    size="20"
                    class="mr-3"
                    @click="$emit('showHistory', item)"
                >
                    mdi-history
                </v-icon>
                <v-icon
                    v-if="visibilityConfig.actions.restore"
                    size="20"
                    class="mr-3"
                    @click="$emit('restore', item)"
                >
                    mdi-undo
                </v-icon>
            </div>
        </template>
    </v-data-table>
</template>

<script>
import dayjs from 'dayjs';

export default {
    name: 'contractList',

    props: {
        visibilityConfig: {
            type: Object,
            required: false,
            default: () => ({
                actions: {
                    edit: true,
                    delete: true,
                    showHistory: true,
                    restore: true
                },
                search: true,
                refresh: true,
                excludeHeaders: null
            })
        },
        contracts: {
            type: Array,
            required: true
        }
    },

    components: {
        contractEditStatus: () => import('@/components/ContractEditStatus')
    },

    data() {
        return {
            headers: [
                {
                    text: this.$t('employeesView.headers.firstName'),
                    value: 'user.firstName'
                },
                {
                    text: this.$t('employeesView.headers.lastName'),
                    value: 'user.lastName'
                },
                {
                    text: this.$t('contractsView.headers.position'),
                    value: 'position'
                },
                {
                    text: this.$t('contractsView.headers.startDate'),
                    value: 'startDate'
                },
                {
                    text: this.$t('contractsView.headers.endDate'),
                    value: 'endDate'
                },
                {
                    text: this.$t('contractsView.headers.calculatedDaysOff'),
                    value: 'calculatedDaysOff'
                },
                {
                    text: this.$t('contractsView.headers.createdAt'),
                    value: 'createdAt'
                },
                {
                    text: this.$t('contractsView.headers.status'),
                    value: 'status'
                },
                {
                    text: this.$t('contractsView.headers.actions'),
                    value: 'action'
                }
            ],
            search: '',
            sortBy: 'createdAt',
            sortDesc: true
        };
    },

    created() {
        if (this.visibilityConfig.excludeHeaders) {
            this.headers = this.headers.filter(
                header =>
                    !this.visibilityConfig.excludeHeaders.includes(header.value)
            );
        }
    },

    methods: {
        filterNameOrDate(value, search, item) {
            if (!search || !item) {
                return;
            }

            if (!search.match('[0-9]+') && item.user) {
                const fullName = `${item.user.firstName} ${item.user.lastName}`.toLowerCase();

                const searchWords = search.toLowerCase().split(' ');

                return searchWords.every(word => fullName.indexOf(word) !== -1);
            }

            const searchDateFormatted = dayjs(Date.parse(search)).format(
                'YYYY-MM-DD'
            );

            return item.endDate === searchDateFormatted;
        }
    }
};
</script>
